module.exports = __webpack_public_path__ + "img/teacher_bg.88fae5e9.png";